import React from 'react';
import { Select } from 'antd';
import { shutdownReasonsQuery } from '../../../../../../shared/api/queries';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { fieldNames } from '../../../config';
import { getValidationRules } from './utils';
import {
  useSetSelectValueSubscription,
  valueTypes,
} from '../../../lib/subscriptions';

const { useShutdownReasons } = shutdownReasonsQuery;
const { Option } = Select;
const fieldName = fieldNames.reason;

const ReasonField = ({ form, initialValue, editMode }) => {
  const { data, isFetching } = useShutdownReasons({ staleTime: Infinity });

  useSetSelectValueSubscription({
    fieldName,
    data,
    valueType: valueTypes.number,
    form,
  });

  return (
    <Field
      fieldType={fieldTypes.select}
      form={form}
      name={fieldName}
      label="Причина"
      decoratorOptions={{
        rules: getValidationRules({ initialValue, editMode }),
        initialValue: data?.length ? initialValue : undefined,
      }}
      fieldProps={{
        placeholder: 'Выберите причину',
        loading: isFetching,
        showSearch: true,
        optionFilterProp: 'searchtext',
      }}
      items={data}
      renderOption={(item) => (
        <Option
          key={item.id}
          value={item.id}
          searchtext={item.name}
        >
          {item.name}
        </Option>
      )}
    />
  );
};

export default ReasonField;
